<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="mw-970 mx-auto">
                    <booking-trip-leg leg="out" :offers="offers.out" :prices="prices.out" :loading="loading" @showInfo="showInfo"></booking-trip-leg>

                    <error v-if="!loading && errors.out" :message="errors.out"></error>

                    <booking-trip-leg leg="ret" :offers="offers.ret" :prices="prices.ret" v-if="ticket == 'return'" :loading="loading" @showInfo="showInfo"></booking-trip-leg>

                    <error v-if="ticket == 'return' && !loading && errors.ret" :message="errors.ret"></error>

                    <div class="c-section">
                        <div class="mt-4 pt-2 text-right">
                            <button class="btn btn-primary is-wide" type="button" @click="submit">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BookingTripLeg from './BookingTripLeg.vue'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import Error from '../components/Error.vue'
export default {
    components: { BookingTripLeg, Error },
    data() {
        return {
            prices: {
                out: [],
                ret: [],
            },
            offers: {
                out: [],
                ret: [],
            },
            loading: false,
        }
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'ticket',
            'passengersCount',
            'accommodationClass',
        ]),
        ...mapGetters([
            'getPortById'
        ]),
        selectedDates() {
            return {
                out: this.legs.out.date,
                ret: this.legs.ret.date,
            }
        },
        selectedTrips() {
            return {
                out: this.legs.out.trip,
                ret: this.legs.ret.trip,
                accommodationClass: this.accommodationClass,
            }
        },
        errors() {
            let errors = {
                out: '',
                ret: '',
            }

            if (!this.offers.out.length) {
                errors.out = 'There are no trips available on the selected date. Please try selecting another date above or go back and modify your search'
            }

            if (this.ticket == 'return') {
                if (!this.offers.ret.length) {
                    errors.ret = 'There are no trips available on the selected date. Please try selecting another date above or go back and modify your search'

                    if (this.offers.out.length) {
                        errors.out = 'Please select the return date'
                    }
                }
                else if (!this.offers.ret.length) {
                    errors.ret = 'Please select the outward date'
                }
            }

            return errors
        },
    },
    created() {
        this.getQuote()
    },
    mounted() {
        this.track({
            event: 'start_booking',
            departure_date: this.legs.out.date,
            from: this.getPortById(this.legs.out.origin).name,
            to: this.getPortById(this.legs.out.destination).name,
            return_date: this.ticket == 'return' ? this.legs.ret.date : '',
            return_from: this.ticket == 'return' ? this.getPortById(this.legs.out.origin).name : '',
            return_to: this.ticket == 'return' ? this.getPortById(this.legs.out.destination).name : '',
            passengers: JSON.parse(JSON.stringify(this.passengersCount))
        })
        this.getPrices()
        this.getOffers()
        this.$scrollTo('body')
    },
    watch: {
        selectedDates: {
            deep: true,
            async handler() {
                let outDate = moment(this.selectedDates.out)
                let retDate = moment(this.selectedDates.ret)

                if (this.ticket != 'oneway') {
                    if (this.ticket == 'daytrip' && retDate.isBefore(outDate)) {
                        return
                    }
                    else if (this.ticket == 'return' && retDate.isSameOrBefore(outDate)) {
                        return
                    }
                }
                await this.getPrices()
                await this.getOffers()
            }
        },
        selectedTrips: {
            deep: true,
            handler() {
                if (this.ticket == 'return') {
                    if (this.selectedTrips.out && ! this.selectedTrips.ret) {
                        if (this.offers.ret.length) {
                            this.setTrip({
                                trip: this.offers.ret[0],
                                leg: 'ret',
                            })
                        }
                    }
                    if (this.selectedTrips.ret && ! this.selectedTrips.out) {
                        if (this.offers.out.length) {
                            this.setTrip({
                                trip: this.offers.out[0],
                                leg: 'out',
                            })
                        }
                    }
                }
                //this.getQuote()
            },
        },
    },
    methods: {
        showInfo(section) {
            this.$emit('showInfo', section)
        },
        ...mapMutations('booking', [
            'setTrip'
        ]),
        ...mapActions('booking', [
            'getLuggageInfo',
            'startBooking',
            'getQuote',
        ]),
        async submit() {
            if (!this.legs.out.origin || !this.legs.out.destination || !this.legs.out.trip) {
                this.$swal('Error', this.ticket == 'oneway' ? 'Please select a ticket' : 'Please select the outward ticket', 'error')
                return
            }
            if (this.ticket != 'oneway' && (!this.legs.out.origin || !this.legs.out.destination || !this.legs.out.trip)) {
                this.$swal('Error', 'Please select the return ticket', 'error')
                return
            }
            this.startBooking()
        },
        async getPrices() {
            let outDate = moment(this.legs.out.date)
            let outDateFrom = moment(outDate).subtract(7, 'days')
            let now = moment()
            if (outDateFrom.isBefore(now)) {
                outDateFrom = moment(now)
            }
            let outDateTo = moment(outDateFrom).add(14, 'days')

            if (!this.legs.out.date || !this.legs.out.origin || !this.legs.out.destination || !this.passengersCount.adl) {
                return { out: [], ret: [] }
            }

            let params = {
                out_date: this.legs.out.date,
                out_origin_id: this.legs.out.origin,
                out_destination_id: this.legs.out.destination,
                out_date_from: outDateFrom.format('YYYY-MM-DD'),
                out_date_to: outDateTo.format('YYYY-MM-DD'),
                passengers: {}
            }
            Object.keys(this.passengersCount).forEach(key => {
                params.passengers[key.toUpperCase()] = this.passengersCount[key]
            })

            if (this.ticket == 'return') {
                let retDate = moment(this.legs.ret.date)
                let retDateFrom = moment(retDate).subtract(7, 'days')
                if (retDateFrom.isSameOrBefore(outDate)) {
                    retDateFrom = moment(outDate).add(1, 'days')
                }
                let retDateTo = moment(retDateFrom).add(14, 'days')   
                if (!this.legs.ret.date || !this.legs.ret.origin || !this.legs.ret.destination) {
                    return { out: [], ret: [] }
                }
                params = {
                    ...params,
                    ret_date: this.legs.ret.date,
                    ret_origin_id: this.legs.ret.origin,
                    ret_destination_id: this.legs.ret.destination,
                    ret_date_from: retDateFrom.format('YYYY-MM-DD'),
                    ret_date_to: retDateTo.format('YYYY-MM-DD'),
                }
            }

            this.prices = await this.$api.prices(params)
        },
        async getOffers() {
            this.loading = true
            let params = {
                out_origin_id: this.legs.out.origin,
                out_destination_id: this.legs.out.destination,
                out_date: this.legs.out.date,
                passengers: {},
            }
            Object.keys(this.passengersCount).forEach(
                key => params.passengers[key.toUpperCase()] = this.passengersCount[key]
            )

            if (this.ticket == 'return') {
                params = {
                    ...params,
                    ret_origin_id: this.legs.ret.origin,
                    ret_destination_id: this.legs.ret.destination,
                    ret_date: this.legs.ret.date,
                }
            }

            this.offers = await this.$api.offers(params)
            this.loading = false

            if (this.selectedTrips.out && !this.offers.out.find(trip => trip.id == this.selectedTrips.out.id)) {
                this.setTrip({ trip: null, leg: 'out' })
            }
            if (this.ticket == 'return' && this.selectedTrips.ret && !this.offers.ret.find(trip => trip.id == this.selectedTrips.ret.id)) {
                this.setTrip({ trip: null, leg: 'ret' })
            }
        },
    },
}
</script>